import { render, staticRenderFns } from "./TenancySettings.vue?vue&type=template&id=0bef00b7&"
import script from "./TenancySettings.vue?vue&type=script&lang=js&"
export * from "./TenancySettings.vue?vue&type=script&lang=js&"
import style0 from "./TenancySettings.vue?vue&type=style&index=0&id=0bef00b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports